import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/main_tech.svg")